export const screens = {
    md: "(min-width:40em)"
}